import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import FooterBangla from "../../components/componentsBangla/FooterBangla";
import HeaderOthersBangla from "../../components/componentsBangla/HeaderOthersBangla";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "60px 0px",
  },
  title: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
    textAlign: "center",
  },
  content: {
    fontSize: "1rem",
    marginBottom: "20px !important",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "20px !important",
    fontWeight: "500 !important",
  },

  icon: {
    marginRight: 10,
    position: "relative",
    top: 5,
  },
  select: {
    marginBottom: 30,
  },
  footer: {
    marginTop: "-80px",
  },
  note: {
      backgroundColor: "#e8f4f8",
      padding: "10px",
      borderLeft: "4px solid #007bff",
      margin: "10px 0",
      fontStyle: "italic"
  }
}));

const PrivacyPolicyBangla = () => {
  const classes = useStyle();

  useEffect(() => {
    window.scrollTo(0, -1);
  }, []);

  return (
    <>
      <HeaderOthersBangla title="Privacy Policy" />
      <div className={classes.root}>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid item md={12}>
              <Typography className={classes.title}>
                গোপনীয়তা পলিসি - এসটি পে
              </Typography>
              <p>
                {" "}
                এই প্রাইভেসি পলিসিতে এসটি পে কীভাবে এর ব্যবহারকারীদের
                ("ব্যবহারকারী") ব্যক্তিগত ডেটা ("ব্যক্তিগত ডেটা") সংগ্রহ,
                প্রক্রিয়াজাতকরণ, সংরক্ষণ এবং সুরক্ষিত করে, তা বর্ণনা করা
                হয়েছে। এটি এসটি পে এর ওয়েবসাইট, মোবাইল অ্যাপ্লিকেশন এবং
                সম্পর্কিত সেবাসমূহ (“প্ল্যাটফর্ম”) এর সকল ব্যবহারকারীর জন্য
                প্রযোজ্য। প্রযোজ্য আইন এবং আমাদের অভ্যন্তরীণ নীতিমালার সাথে
                সামঞ্জস্য রেখে আপনার ব্যক্তিগত ডেটা কীভাবে ব্যবস্থাপনা করা হয়
                তা বুঝতে এই প্রাইভেসি পলিসি মনোযোগ সহকারে পড়ুন।{" "}
              </p>{" "}
              <h2>১. প্রযোজ্যতা এবং ক্ষেত্র</h2>{" "}
              <p>
                {" "}
                আমাদের প্ল্যাটফর্ম ব্যবহার করার মাধ্যমে আপনি এই প্রাইভেসি পলিসির
                শর্তাবলীতে সম্মতি প্রদান করছেন। আমরা কিছু ব্যক্তিগতভাবে
                সনাক্তযোগ্য তথ্য (PII), যেমন জাতীয় পরিচয়পত্র, পাসপোর্ট নম্বর,
                ড্রাইভিং লাইসেন্স, TIN এবং ব্যাংক অ্যাকাউন্টের বিবরণ সংগ্রহ করতে
                পারি নিয়ন্ত্রক সম্মতি নিশ্চিত করতে এবং প্রতারণা, অর্থপাচার এবং
                সন্ত্রাসবাদ অর্থায়ন সম্পর্কিত ঝুঁকি হ্রাস করতে।{" "}
              </p>{" "}
              <h2>২. আমরা যে তথ্য সংগ্রহ করি</h2> <h3>ক. ব্যক্তিগত তথ্য</h3>{" "}
              <p>
                যখন আপনি এসটি পে-এ নিবন্ধন বা ব্যবহার করেন, তখন আমরা সংগ্রহ করতে
                পারি:
              </p>{" "}
              <ul>
                {" "}
                <li>পূর্ণ নাম</li> <li>মোবাইল নম্বর</li> <li>ইমেইল ঠিকানা</li>{" "}
                <li>জাতীয় পরিচয়পত্র (NID)</li> <li>পাসপোর্ট নম্বর</li>{" "}
                <li>জন্ম নিবন্ধন নম্বর</li>{" "}
                <li>প্রয়োজনীয় অন্যান্য পরিচয়পত্র</li>{" "}
              </ul>{" "}
              <div className={classes.note}> 
                <strong>দ্রষ্টব্য:</strong> এই ডেটা নিরাপদে সংরক্ষিত হয় এবং
                আপনার সম্মতি ছাড়া অপ্রাসঙ্গিক তৃতীয় পক্ষের সাথে বিক্রি, লেনদেন
                বা ভাগ করা হয় না।
              </div>{" "}
              <h3>খ. ডিভাইস তথ্য</h3>{" "}
              <p>
                {" "}
                আমরা আপনার ডিভাইস এবং প্ল্যাটফর্মের সাথে আপনার ইন্টারঅ্যাকশন
                সম্পর্কিত তথ্য সংগ্রহ করি, যেমন:{" "}
              </p>{" "}
              <ul>
                {" "}
                <li>ডিভাইস আইডি এবং প্রকার</li>{" "}
                <li>অপারেটিং সিস্টেম এবং ভার্সন</li>{" "}
                <li>সংযোগ এবং ব্রাউজার সম্পর্কিত তথ্য</li>{" "}
              </ul>{" "}
              <h3>গ. লেনদেন সংক্রান্ত তথ্য</h3>{" "}
              <p>
                {" "}
                বাংলাদেশের নিম্নলিখিত আইনসমূহ অনুযায়ী সকল আর্থিক লেনদেন লগ করা
                হয়:{" "}
              </p>{" "}
              <ul>
                {" "}
                <li>অর্থপাচার প্রতিরোধ আইন, ২০১২</li>{" "}
                <li>সন্ত্রাস বিরোধী আইন, ২০০৯</li>{" "}
                <li>এবং অন্যান্য প্রযোজ্য আইন ও বিধিবিধান</li>{" "}
              </ul>{" "}
              <p>
                {" "}
                অস্বাভাবিক বা উচ্চ-মাত্রার লেনদেনের ক্ষেত্রে অতিরিক্ত যাচাই
                প্রয়োজন হতে পারে।{" "}
              </p>{" "}
              <h3>ঘ. এসএমএস অনুমতি</h3>{" "}
              <p>
                আমরা কেবল নিচের ক্ষেত্রে OTP যাচাইয়ের জন্য SMS ব্যবহার করি:
              </p>{" "}
              <ul>
                {" "}
                <li>অ্যাকাউন্ট নিবন্ধন</li> <li>নতুন ডিভাইস থেকে লগইন</li>{" "}
              </ul>{" "}
              <h3>ঙ. লগ ডেটা</h3> <p>আমরা সংগ্রহ করতে পারি:</p>{" "}
              <ul>
                {" "}
                <li>IP ঠিকানা</li> <li>ডিভাইসের নাম এবং অপারেটিং সিস্টেম</li>{" "}
                <li>অ্যাপ কনফিগারেশন এবং ব্যবহার সময়</li>{" "}
                <li>ডায়াগনস্টিক এবং ক্র্যাশ সম্পর্কিত ডেটা</li>{" "}
              </ul>{" "}
              <h3>চ. ওয়েব ব্যবহার এবং কুকিজ</h3>{" "}
              <p>সেবার মান উন্নয়নের জন্য আমরা ট্র্যাক করি:</p>{" "}
              <ul>
                {" "}
                <li>IP এবং ব্রাউজার সম্পর্কিত তথ্য</li> <li>রেফারার URL</li>{" "}
                <li>সেশন কুকিজ, ওয়েব বিকন এবং অনুরূপ প্রযুক্তি</li>{" "}
              </ul>{" "}
              <h2>৩. সংগ্রহকৃত তথ্যের ব্যবহার</h2>{" "}
              <p>আমরা আপনার তথ্য ব্যবহার করি:</p>{" "}
              <ul>
                {" "}
                <li>নিরাপদ এবং ব্যক্তিগতকৃত সেবা প্রদানের জন্য</li>{" "}
                <li>প্রতারণামূলক বা অবৈধ কার্যক্রম প্রতিরোধে</li>{" "}
                <li>সন্দেহজনক লেনদেন বা ব্যবহারকারীর অভিযোগ তদন্তে</li>{" "}
                <li>আর্থিক নিয়ন্ত্রক নীতিমালা মেনে চলার জন্য</li>{" "}
                <li>অডিট এবং নিয়ন্ত্রক পরিদর্শনের সহায়তায়</li>{" "}
              </ul>{" "}
              <p>
                {" "}
                এসটি পে সেবা সম্পর্কিত আপডেট, লেনদেনের নোটিফিকেশন এবং
                কমপ্লায়েন্স যাচাইয়ের জন্য আপনার দেওয়া যোগাযোগের তথ্য ব্যবহার
                করে আপনার সাথে যোগাযোগ করবে।{" "}
              </p>{" "}
              <h2>৪. তথ্য ভাগাভাগি এবং প্রকাশ</h2>{" "}
              <p>এসটি পে নিম্নলিখিত সংস্থার সাথে আপনার তথ্য ভাগ করতে পারে:</p>{" "}
              <ul>
                {" "}
                <li>
                  আইনগতভাবে প্রমাণিত অনুরোধের ভিত্তিতে সরকার বা নিয়ন্ত্রক
                  সংস্থা
                </li>{" "}
                <li>
                  সেবা প্রক্রিয়াকরণের জন্য পার্টনার ব্যাংক, পেমেন্ট গেটওয়ে এবং
                  আর্থিক প্রতিষ্ঠান
                </li>{" "}
                <li>
                  অপারেশনাল সেবা প্রদানকারী তৃতীয় পক্ষ (যেমন KYC, প্রতারণা
                  প্রতিরোধ, অ্যানালিটিক্স)
                </li>{" "}
                <li>আইন অনুযায়ী প্রয়োজন হলে সহযোগী এবং পার্টনারদের সাথে</li>{" "}
              </ul>{" "}
              <p>আমরা তথ্য প্রকাশ করতে পারি:</p>{" "}
              <ul>
                {" "}
                <li>ব্যবসায়িক একীভূকরণ, অধিগ্রহণ বা পুনর্গঠনের সময়</li>{" "}
                <li>আইনগত বাধ্যবাধকতার কারণে (যেমন আদালতের আদেশ)</li>{" "}
                <li>আসন্ন শারীরিক বা আর্থিক ক্ষতি প্রতিরোধের জন্য</li>{" "}
              </ul>{" "}
              <h2>৫. অ্যাক্সেস এবং সংশোধন</h2> <p>ব্যবহারকারীরা:</p>{" "}
              <ul>
                {" "}
                <li>
                  তাদের অ্যাকাউন্ট সেটিংসের মাধ্যমে ব্যক্তিগত তথ্য অ্যাক্সেস এবং
                  হালনাগাদ করতে পারবেন
                </li>{" "}
                <li>ভুল বা অসম্পূর্ণ তথ্য সংশোধনের জন্য অনুরোধ করতে পারবেন</li>{" "}
                <li>
                  তথ্য সংশোধনের জন্য আমাদের সাথে যোগাযোগ করতে পারবেন (প্রশাসনিক
                  চার্জ প্রযোজ্য হতে পারে)
                </li>{" "}
              </ul>{" "}
              <h2>৬. ডেটা সংরক্ষণ এবং স্থানান্তর</h2>{" "}
              <p>
                {" "}
                আপনার ডেটা বাংলাদেশের সার্ভারে নিরাপদে সংরক্ষিত হয়। আমরা
                শক্তিশালী নিরাপত্তা ব্যবস্থা গ্রহণ করলেও, ইন্টারনেটের মাধ্যমে
                তথ্য স্থানান্তরের ক্ষেত্রে কিছু ঝুঁকি থেকে যায়। আপনার লগইন তথ্য
                গোপন রাখার দায়িত্ব আপনার।{" "}
              </p>{" "}
              <h2>৭. সেবা প্রদানকারী</h2>{" "}
              <p>আমরা তৃতীয় পক্ষের প্রদানকারীদের নিযুক্ত করতে পারি:</p>{" "}
              <ul>
                {" "}
                <li>আমাদের পক্ষে সেবা প্রদানের জন্য</li>{" "}
                <li>প্রতারণা বা ঝুঁকির মূল্যায়ন করার জন্য</li>{" "}
                <li>প্রযুক্তিগত বা সহায়তা সেবা প্রদানের জন্য</li>{" "}
              </ul>{" "}
              <p>
                {" "}
                এই পক্ষগুলো চুক্তিভিত্তিকভাবে আপনার ডেটার সুরক্ষা নিশ্চিত করতে
                এবং এটি অন্য কোনো উদ্দেশ্যে ব্যবহার না করার বাধ্যবদ্ধ।{" "}
              </p>{" "}
              <h2>৮. নিরাপত্তা ব্যবস্থা</h2>{" "}
              <p>আমরা নিম্নলিখিত শিল্পমানের নিরাপত্তা ব্যবস্থা গ্রহণ করি:</p>{" "}
              <ul>
                {" "}
                <li>এনক্রিপশন</li> <li>নিরাপদ প্রমাণীকরণ</li>{" "}
                <li>নিয়মিত অডিট</li>{" "}
              </ul>{" "}
              <p>
                {" "}
                একটি শক্তিশালী পাসওয়ার্ড এবং/অথবা PIN ব্যবহার করে আপনার
                অ্যাকাউন্ট সুরক্ষিত করুন। আপনার লগইন তথ্য অন্য কারো সাথে শেয়ার
                করবেন না। আপনার লগইন ব্যবহার করে করা যেকোনো কার্যকলাপের দায়
                আপনার।{" "}
              </p>{" "}
              <h2>৯. বহিরাগত সাইটের লিঙ্ক</h2>{" "}
              <p>
                {" "}
                আমাদের প্ল্যাটফর্মে তৃতীয় পক্ষের ওয়েবসাইটের লিঙ্ক থাকতে পারে।
                এই সাইটগুলোর কন্টেন্ট বা প্রাইভেসি নীতির জন্য আমরা দায়ী নই।
                তাদের প্রাইভেসি নীতি পর্যালোচনা করে ব্যবহার করুন।{" "}
              </p>{" "}
              <h2>১০. একীভূকরণ এবং অধিগ্রহণ</h2>{" "}
              <p>
                {" "}
                একীভূকরণ বা অধিগ্রহণের ক্ষেত্রে, আপনার ডেটা নতুন প্রতিষ্ঠানে
                স্থানান্তরিত হতে পারে, যা এই প্রাইভেসি পলিসি মেনে চলতে বাধ্য
                থাকবে।{" "}
              </p>{" "}
              <h2>১১. প্রাইভেসি পলিসির হালনাগাদ</h2>{" "}
              <p>
                {" "}
                এসটি পে যে কোনো সময় এই প্রাইভেসি পলিসি সংশোধন করতে পারে।
                হালনাগাদ হওয়া শর্তাবলী এই পৃষ্ঠায় প্রকাশের সাথে সাথেই কার্যকর
                হবে। হালনাগাদ হওয়ার পর আমাদের সেবা ব্যবহার চালিয়ে গেলে, আপনি
                সংশোধিত প্রাইভেসি পলিসিতে সম্মত হচ্ছেন বলে ধরা হবে। পরিবর্তনের
                জন্য নিয়মিত এই পৃষ্ঠাটি পর্যালোচনা করার জন্য আমরা আপনাকে
                উৎসাহিত করছি।{" "}
              </p>
              
              <br />
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className={classes.footer}>
        <FooterBangla />
      </div>
    </>
  );
};

export default PrivacyPolicyBangla;
